'use client';

import { VideosTabList } from '@ninjacart/nc-nk-discovery';

export function VideosListTabLayout() {
  return <VideosTabList />
}
